import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { PremissasService } from '../services/premissas.service';

@Directive({
  selector: '[appValidaInscricaoEstadual]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidaInscricaoEstadualDirective, multi: true }]
})
export class ValidaInscricaoEstadualDirective implements Validator {
  @Input('appValidaInscricaoEstadual') uf: string;
  @Input() ieObg: boolean;

  constructor(private premissasService: PremissasService) {}

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (this.ieObg && !this.validarInscricaoEstadual(this.uf, control.value)) {
      return { erro: 'Inscrição Estadual inválida' };
    }

    return null;
  }

  validarInscricaoEstadual(uf: string, ie: string) {
    if (ie === undefined || ie === null || ie === '') return true;

    if (uf === undefined || uf === null) return false;

    if (uf.length !== 2) return false;

    if (ie.length === 0) return false;

    ie = ie
      .trim()
      .replace(new RegExp('[-]', 'g'), '')
      .replace(new RegExp('[.]', 'g'), '')
      .replace(new RegExp('[/]', 'g'), '')
      .toUpperCase();

    if (ie === 'ISENTO') return true;

    if (Number(ie) === 0) return false;

    try {
      switch (uf.toUpperCase()) {
        case 'AC':
          return this.validaIE_AC(ie);

        case 'AL':
          return this.validaIE_AL(ie);

        case 'AM':
          return this.validaIE_AM(ie);

        case 'AP':
          return this.validaIE_AP(ie);

        case 'BA':
          return this.validaIE_BA(ie);

        case 'CE':
          return this.validaIE_CE(ie);

        case 'DF':
          return this.validaIE_DF(ie);

        case 'ES':
          return this.validaIE_ES(ie);

        case 'GO':
          return this.validaIE_GO(ie);

        case 'MA':
          return this.validaIE_MA(ie);

        case 'MT':
          return this.validaIE_MT(ie);

        case 'MS':
          return this.validaIE_MS(ie);

        case 'MG':
          return this.validaIE_MG(ie);

        case 'PA':
          return this.validaIE_PA(ie);

        case 'PB':
          return this.validaIE_PB(ie);

        case 'PE':
          return this.validaIE_PE(ie);

        case 'PI':
          return this.validaIE_PI(ie);

        case 'PR':
          return this.validaIE_PR(ie);

        case 'RJ':
          return this.validaIE_RJ(ie);

        case 'RN':
          return this.validaIE_RN(ie);

        case 'RO':
          return this.validaIE_RO(ie);

        case 'RR':
          return this.validaIE_RR(ie);

        case 'RS':
          return this.validaIE_RS(ie);

        case 'SC':
          return this.validaIE_SC(ie);

        case 'SE':
          return this.validaIE_SE(ie);

        case 'SP':
          return this.validaIE_SP(ie);

        case 'TO':
          return this.validaIE_TO(ie);

        default:
          return false;
      }
    } catch (erro) {
      return false;
    }
  }

  validaIE_AC(ie: string) {
    if (ie.length !== 13 || ie.substr(0, 2) !== '01') return false;

    let strBase = ie.trim();

    if (strBase.substr(0, 2) !== '01') return false;

    let intSoma = 0;
    let intPeso = 4;
    let intValor = 0;

    for (let intPos = 1; intPos <= 11; intPos++) {
      intValor = Number(strBase.substr(intPos - 1, 1));

      if (intPeso === 1) intPeso = 9;

      intSoma += intValor * intPeso;

      intPeso--;
    }

    let intResto = intSoma % 11;

    intSoma = 0;
    strBase = (ie.trim() + '000000000000').substr(0, 12);
    intPeso = 5;

    for (let intPos = 1; intPos <= 12; intPos++) {
      intValor = Number(strBase.substr(intPos - 1, 1));

      if (intPeso == 1) intPeso = 9;

      intSoma += intValor * intPeso;
      intPeso--;
    }

    intResto = intSoma % 11;
    let strDigito2 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );

    let strBase2 = strBase.substr(0, 12) + strDigito2;

    return strBase2 == ie;
  }

  validaIE_AL(ie: string) {
    if (ie.length != 9 || ie.substr(0, 2) != '24') return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);

    if (strBase.substr(0, 2) != '24') return false;

    let intSoma = 0;
    let intPeso = 9;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));

      intSoma += intValor * intPeso;
      intPeso--;
    }

    intSoma = intSoma * 10;
    let intResto = intSoma % 11;

    let strDigito1 = (intResto == 10 ? '0' : intResto.toString()).substr(
      (intResto == 10 ? '0' : intResto.toString()).length - 1
    );

    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_AM(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;
    let intPeso = 9;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));

      intSoma += intValor * intPeso;
      intPeso--;
    }

    let intResto = intSoma % 11;
    let strDigito1 =
      intSoma < 11
        ? (11 - intSoma).toString()
        : (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
            (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
          );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_AP(ie: string) {
    ie = ie.trim();

    // A IE do Amapá deve ter 9 dígitos e começar com 03
    if (!/^03\d{7}$/.test(ie)) return false;

    const strBase = ie.substr(0, 8);
    const numeroBase = Number(strBase);

    let p = 0;
    let d = 0;

    // Define os valores P e D conforme a faixa da inscrição
    if (numeroBase >= 3000001 && numeroBase <= 3017000) {
      p = 5;
      d = 0;
    } else if (numeroBase >= 3017001 && numeroBase <= 3019022) {
      p = 9;
      d = 1;
    } else if (numeroBase >= 3019023) {
      p = 0;
      d = 0;
    } else {
      return false;
    }

    let intSoma = p;
    let intPeso = 9;

    for (let intPos = 0; intPos < 8; intPos++) {
      const intValor = Number(strBase.substr(intPos, 1));

      intSoma += intValor * intPeso;
      intPeso--;
    }

    const intResto = intSoma % 11;

    let digito = 11 - intResto;

    if (digito === 10) {
      digito = 0;
    } else if (digito === 11) {
      digito = d;
    }

    return digito === Number(ie.substr(8, 1));

    // if (ie.length != 9) return false;

    // let strBase = (ie.trim() + '000000000').substr(0, 9);
    // let intPeso = 9;

    // if (strBase.substr(0, 2) != '03') return false;

    // strBase = (ie.trim() + '000000000').substr(0, 9);
    // let intSoma = 0;

    // let intValor;
    // for (let intPos = 1; intPos <= 8; intPos++) {
    //   intValor = Number(strBase.substr(intPos - 1, 1));

    //   intSoma += intValor * intPeso;
    //   intPeso--;
    // }

    // let intResto = intSoma % 11;
    // intValor = 11 - intResto;

    // let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    // let strBase2 = strBase.substr(0, 8) + strDigito1;

    // return strBase2 == ie;
  }

  validaIE_BA(ie: string) {
    if (ie.length != 9 && ie.length != 8) return false;

    let strBase = '';

    switch (ie.length) {
      case 8:
        strBase = (ie.trim() + '00000000').substr(0, 8);
        break;
      case 9:
        strBase = (ie.trim() + '00000000').substr(0, 9);
        break;
    }

    let intSoma = 0;
    let intValor;
    let intPeso = 0;
    let intResto;
    let strDigito1 = '';
    let strDigito2 = '';
    let strBase2 = '';

    if (strBase.length == 8) {
      if ('0123458'.indexOf(strBase.substr(0, 1), 0) + 1 > 0) {
        for (let intPos = 1; intPos <= 6; intPos++) {
          intValor = Number(strBase.substr(intPos - 1, 1));

          if (intPos == 1) intPeso = 7;

          intSoma += intValor * intPeso;
          intPeso--;
        }

        intResto = intSoma % 10;
        strDigito2 = (intResto == 0 ? '0' : (10 - intResto).toString()).substr(
          (intResto == 0 ? '0' : (10 - intResto).toString()).length - 1
        );

        strBase2 = strBase.substr(0, 7) + strDigito2;

        if (strBase2 == ie) {
          intSoma = 0;
          intPeso = 0;

          for (let intPos = 1; intPos <= 7; intPos++) {
            intValor = Number(strBase.substr(intPos - 1, 1));

            if (intPos == 7) intValor = Number(strBase.substr(intPos, 1));

            if (intPos == 1) intPeso = 8;

            intSoma += intValor * intPeso;
            intPeso--;
          }

          intResto = intSoma % 10;
          strDigito1 = (intResto == 0 ? '0' : (10 - intResto).toString()).substr(
            (intResto == 0 ? '0' : (10 - intResto).toString()).length - 1
          );

          strBase2 = strBase.substr(0, 6) + strDigito1 + strDigito2;

          return strBase2 == ie;
        }

        return false;
      }

      if ('679'.indexOf(strBase.substr(0, 1), 0) + 1 > 0) {
        intSoma = 0;

        for (let intPos = 1; intPos <= 6; intPos++) {
          intValor = Number(strBase.substr(intPos - 1, 1));

          if (intPos == 1) intPeso = 7;

          intSoma += intValor * intPeso;
          intPeso--;
        }

        intResto = intSoma % 11;
        strDigito2 = (intResto == 0 ? '0' : (11 - intResto).toString()).substr(
          (intResto == 0 ? '0' : (11 - intResto).toString()).length - 1
        );

        strBase2 = strBase.substr(0, 7) + strDigito2;

        if (strBase2 == ie) {
          intSoma = 0;
          intPeso = 0;

          for (let intPos = 1; intPos <= 7; intPos++) {
            intValor = Number(strBase.substr(intPos - 1, 1));

            if (intPos == 7) intValor = Number(strBase.substr(intPos, 1));

            if (intPos == 1) intPeso = 8;

            intSoma += intValor * intPeso;
            intPeso--;
          }

          intResto = intSoma % 11;
          strDigito1 = (intResto == 0 ? '0' : (11 - intResto).toString()).substr(
            (intResto == 0 ? '0' : (11 - intResto).toString()).length - 1
          );

          strBase2 = strBase.substr(0, 6) + strDigito1 + strDigito2;

          return strBase2 == ie;
        }

        return false;
      }
    }

    if (strBase.length == 9) {
      let modulo = '0123458'.indexOf(strBase.substr(1, 1), 0) + 1 > 0 ? 10 : 11;

      intSoma = 0;

      for (let intPos = 1; intPos <= 7; intPos++) {
        intValor = Number(strBase.substr(intPos - 1, 1));

        if (intPos == 1) intPeso = 8;

        intSoma += intValor * intPeso;
        intPeso--;
      }

      intResto = intSoma % modulo;

      if (modulo == 11)
        strDigito2 = (intResto == 0 || intResto == 1 ? '0' : (modulo - intResto).toString()).substr(
          (intResto == 0 || intResto == 1 ? '0' : (modulo - intResto).toString()).length - 1
        );
      else
        strDigito2 = (intResto == 0 ? '0' : (modulo - intResto).toString()).substr(
          (intResto == 0 ? '0' : (modulo - intResto).toString()).length - 1
        );

      strBase2 = strBase.substr(0, 8) + strDigito2;

      if (strBase2 == ie) {
        intSoma = 0;
        intPeso = 0;

        for (let intPos = 1; intPos <= 8; intPos++) {
          intValor = Number(strBase.substr(intPos - 1, 1));

          if (intPos == 8) intValor = Number(strBase.substr(intPos, 1));

          if (intPos == 1) intPeso = 9;

          intSoma += intValor * intPeso;
          intPeso--;
        }

        intResto = intSoma % modulo;

        if (modulo == 11)
          strDigito1 = (intResto == 0 || intResto == 1 ? '0' : (modulo - intResto).toString()).substr(
            (intResto == 0 || intResto == 1 ? '0' : (modulo - intResto).toString()).length - 1
          );
        else
          strDigito1 = (intResto == 0 ? '0' : (modulo - intResto).toString()).substr(
            (intResto == 0 ? '0' : (modulo - intResto).toString()).length - 1
          );

        strBase2 = strBase.substr(0, 7) + strDigito1 + strDigito2;

        return strBase2 == ie;
      }

      return false;
    }

    return false;
  }

  validaIE_CE(ie: string) {
    if (ie.length > 9) return false;

    while (ie.length <= 8) ie = '0' + ie;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;
    let intValor = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor > 9) intValor = 0;

    let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_DF(ie: string) {
    if (ie.length != 13) return false;

    let strBase = (ie.trim() + '0000000000000').substr(0, 13);

    let intSoma = 0;
    let intPeso = 2;
    let intValor = 0;

    for (let intPos = 11; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 11) + strDigito1;

    intSoma = 0;
    intPeso = 2;

    for (let intPos = 12; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    intResto = intSoma % 11;
    let strDigito2 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    strBase2 = strBase.substr(0, 12) + strDigito2;

    return strBase2 == ie;
  }

  validaIE_ES(ie: string) {
    if (ie.length != 9) return false;

    let strBase = ie.trim();
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_GO(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);

    if ('10,11,20,21,22,23,24,25,26,27,28,29'.indexOf(strBase.substr(0, 2), 0) + 1 <= 0) return false;

    let intSoma = 0;
    let strDigito1 = '';

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;

    switch (intResto) {
      case 0:
        strDigito1 = '0';
        break;

      case 1: {
        let intNumero = Number(strBase.substr(0, 8));
        strDigito1 = (intNumero >= 10103105 && intNumero <= 10119997 ? '1' : '0').substr(
          (intNumero >= 10103105 && intNumero <= 10119997 ? '1' : '0').length - 1
        );
        break;
      }

      default:
        strDigito1 = (11 - intResto).toString().substr((11 - intResto).toString().length - 1);
        break;
    }

    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_MA(ie: string) {
    if (ie.length != 9 || ie.substr(0, 2) != '12') return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_MT(ie: string) {
    if (ie.length < 9) return false;

    while (ie.length < 11) ie = '0' + ie;

    let strBase = (ie.trim() + '0000000000').substr(0, 10);
    let intSoma = 0;
    let intPeso = 2;

    for (let intPos = 10; intPos >= 1; intPos = intPos + -1) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 10) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_MS(ie: string): boolean {
    if (!ie) return false;

    ie = ie.replace(/\D/g, '');

    if (ie.length !== 9) return false;

    const prefixo = ie.substring(0, 2);

    if (prefixo !== '28' && prefixo !== '50') return false;

    const base = ie.substring(0, 8);
    const dvInformado = parseInt(ie.substring(8, 9), 10);

    const pesos = [9, 8, 7, 6, 5, 4, 3, 2];

    let soma = 0;

    for (let i = 0; i < 8; i++) {
      soma += parseInt(base[i], 10) * pesos[i];
    }

    const resto = soma % 11;

    let dvCalculado = 0;

    if (resto !== 0) {
      const t = 11 - resto;
      dvCalculado = t > 9 ? 0 : t;
    }

    return dvCalculado === dvInformado;
  }

  validaIE_MG(ie: string) {
    if (ie.length != 13) return false;

    if (ie.substr(0, 2).toUpperCase() == 'PR') return true;

    let strBase = (ie.trim() + '0000000000000').substr(0, 13);
    let strBase2 = strBase.substr(0, 3) + '0' + strBase.substr(3, 9);
    let intNumero = 1;

    let intSoma = 0;

    for (let intPos = 0; intPos < 12; intPos++) {
      if (Number(strBase2.substr(intPos, 1)) * intNumero >= 10)
        intSoma += Number(strBase2.substr(intPos, 1)) * intNumero - 9;
      else intSoma += Number(strBase2.substr(intPos, 1)) * intNumero;

      intNumero = intNumero + 1;

      if (intNumero == 3) intNumero = 1;
    }

    intNumero = parseInt((Math.floor((intSoma + 10) / 10) * 10 - intSoma).toString());
    if (intNumero % 10 == 0) intNumero = 0;

    if (intNumero != Number(ie.substr(11, 1))) return false;

    intNumero = 3;
    intSoma = 0;

    for (let intPos = 0; intPos < 12; intPos++) {
      intSoma += Number(ie.substr(intPos, 1)) * intNumero;

      intNumero = intNumero - 1;
      if (intNumero == 1) intNumero = 11;
    }

    intNumero = 11 - (intSoma % 11);
    if (intNumero >= 10) intNumero = 0;

    return intNumero == Number(ie.substr(12, 1));
  }

  validaIE_PA(ie: string) {
    let prefixo = ie.substr(0, 2);

    if (
      ie.length != 9 ||
      (prefixo != '15' && prefixo != '75' && prefixo != '76' && prefixo != '77' && prefixo != '78' && prefixo != '79')
    ) {
      return false;
    }

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_PB(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;
    let intValor;

    for (let intPos = 1; intPos <= 8; intPos++) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor > 9) intValor = 0;

    let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_PE(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '00000000000000').substr(0, 14);
    let intSoma = 0;
    let intPeso = 2;
    let intValor;

    for (let intPos = 7; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    let intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor >= 10) intValor = 0;

    if (intValor != Number(ie.substr(7, 1))) return false;

    let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    let strBase2 = strBase.substr(0, 7) + strDigito1;

    if (strBase2 != ie.substr(0, 8)) return false;

    intSoma = 0;
    intPeso = 2;

    for (let intPos = 8; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor >= 10) intValor = 0;

    return intValor.toString() == ie.substr(8, 1);
  }

  validaIE_PI(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_PR(ie: string) {
    if (ie.length != 10) return false;

    let strBase = (ie.trim() + '0000000000').substr(0, 10);
    let intSoma = 0;
    let intPeso = 2;
    let intValor;

    for (let intPos = 8; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 7) intPeso = 2;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;
    intSoma = 0;
    intPeso = 2;

    for (let intPos = 9; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase2.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 7) intPeso = 2;
    }

    intResto = intSoma % 11;
    let strDigito2 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    strBase2 = strBase2 + strDigito2;

    return strBase2 == ie;
  }

  validaIE_RJ(ie: string) {
    if (ie.length != 8) return false;

    let strBase = (ie.trim() + '00000000').substr(0, 8);
    let intSoma = 0;
    let intPeso = 2;

    for (let intPos = 7; intPos >= 1; intPos = intPos + -1) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 7) intPeso = 2;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 7) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_RN(ie: string) {
    let strBase = '';
    switch (ie.length) {
      case 9:
        strBase = (ie.trim() + '000000000').substr(0, 9);
        break;

      case 10:
        strBase = (ie.trim() + '000000000').substr(0, 10);
        break;
    }

    let intSoma = 0;

    if (strBase.substr(0, 2) == '20' && strBase.length == 9) {
      for (let intPos = 1; intPos <= 8; intPos++) {
        let intValor = Number(strBase.substr(intPos - 1, 1));
        intValor = intValor * (10 - intPos);
        intSoma = intSoma + intValor;
      }

      intSoma = intSoma * 10;
      let intResto = intSoma % 11;
      let strDigito1 = (intResto > 9 ? '0' : intResto.toString()).substr(
        (intResto > 9 ? '0' : intResto.toString()).length - 1
      );
      let strBase2 = strBase.substr(0, 8) + strDigito1;

      return strBase2 == ie;
    }

    if (strBase.length == 10) {
      intSoma = 0;

      for (let intPos = 1; intPos <= 9; intPos++) {
        let intValor = Number(strBase.substr(intPos - 1, 1));
        intValor = intValor * (11 - intPos);
        intSoma = intSoma + intValor;
      }

      intSoma = intSoma * 10;
      let intResto = intSoma % 11;
      let strDigito1 = (intResto > 10 ? '0' : intResto.toString()).substr(
        (intResto > 10 ? '0' : intResto.toString()).length - 1
      );
      let strBase2 = strBase.substr(0, 9) + strDigito1;

      return strBase2 == ie;
    }

    return false;
  }

  validaIE_RO(ie: string) {
    if (ie.length != 14) return false;

    const strBase = ie.substr(0, 13);

    const soma =
      6 * Number(strBase[0]) +
      5 * Number(strBase[1]) +
      4 * Number(strBase[2]) +
      3 * Number(strBase[3]) +
      2 * Number(strBase[4]) +
      9 * Number(strBase[5]) +
      8 * Number(strBase[6]) +
      7 * Number(strBase[7]) +
      6 * Number(strBase[8]) +
      5 * Number(strBase[9]) +
      4 * Number(strBase[10]) +
      3 * Number(strBase[11]) +
      2 * Number(strBase[12]);

    const resto = soma % 11;
    let digito = 11 - resto;

    if (digito == 10 || digito == 11) digito -= 10;

    return digito == Number(ie[13]);
  }

  validaIE_RR(ie: string) {
    if (ie.length != 9 || ie.substr(0, 2) != '24') return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPos;
      intSoma += intValor;
    }

    let intResto = intSoma % 9;
    let strDigito1 = intResto.toString().substr(intResto.toString().length - 1);
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_RS(ie: string) {
    if (ie.length != 10) return false;

    let strBase = (ie.trim() + '0000000000').substr(0, 10);
    let intSoma = 0;
    let intPeso = 2;
    let intValor = 0;

    for (let intPos = 9; intPos >= 1; intPos = intPos + -1) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * intPeso;
      intSoma = intSoma + intValor;
      intPeso = intPeso + 1;

      if (intPeso > 9) intPeso = 2;
    }

    let intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor > 9) intValor = 0;

    let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    let strBase2 = strBase.substr(0, 9) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_SC(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_SE(ie: string) {
    if (ie.length != 9) return false;

    let strBase = (ie.trim() + '000000000').substr(0, 9);
    let intSoma = 0;
    let intValor;

    for (let intPos = 1; intPos <= 8; intPos++) {
      intValor = Number(strBase.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    intValor = 11 - intResto;

    if (intValor > 9) intValor = 0;

    let strDigito1 = intValor.toString().substr(intValor.toString().length - 1);
    let strBase2 = strBase.substr(0, 8) + strDigito1;

    return strBase2 == ie;
  }

  validaIE_SP(ie: string) {
    let strBase;
    let strBase2;
    let intSoma;
    let intPeso;

    if (ie.substr(0, 1) == 'P') {
      strBase = (ie.trim() + '0000000000000').substr(0, 13);
      intSoma = 0;
      intPeso = 1;

      for (let intPos = 1; intPos <= 8; intPos++) {
        let intValor = Number(strBase.substr(intPos, 1));
        intValor = intValor * intPeso;
        intSoma = intSoma + intValor;
        intPeso = intPeso + 1;

        if (intPeso == 2) intPeso = 3;

        if (intPeso == 9) intPeso = 10;
      }

      let intResto = intSoma % 11;
      let strDigito1 = intResto.toString().substr(intResto.toString().length - 1);
      strBase2 = strBase.substr(0, 9) + (strDigito1 + strBase.substr(10, 3));
    } else {
      strBase = (ie.trim() + '000000000000').substr(0, 12);
      intSoma = 0;
      intPeso = 1;

      for (let intPos = 1; intPos <= 8; intPos++) {
        let intValor = Number(strBase.substr(intPos - 1, 1));
        intValor = intValor * intPeso;
        intSoma = intSoma + intValor;
        intPeso = intPeso + 1;

        if (intPeso == 2) intPeso = 3;

        if (intPeso == 9) intPeso = 10;
      }

      let intResto = intSoma % 11;
      let strDigito1 = intResto.toString().substr(intResto.toString().length - 1);
      strBase2 = strBase.substr(0, 8) + (strDigito1 + strBase.substr(9, 2));
      intSoma = 0;
      intPeso = 2;

      for (let intPos = 11; intPos >= 1; intPos = intPos + -1) {
        let intValor = Number(strBase.substr(intPos - 1, 1));
        intValor = intValor * intPeso;
        intSoma = intSoma + intValor;
        intPeso = intPeso + 1;

        if (intPeso > 10) intPeso = 2;
      }

      intResto = intSoma % 11;
      let strDigito2 = intResto.toString().substr(intResto.toString().length - 1);
      strBase2 = strBase2 + strDigito2;
    }

    return strBase2 == ie;
  }

  validaIE_TO(ie: string) {
    if (
      (ie.length != 11 && ie.length != 9) ||
      (ie.length === 11 &&
        ie.substr(2, 2) != '01' &&
        ie.substr(2, 2) != '02' &&
        ie.substr(2, 2) != '03' &&
        ie.substr(2, 2) != '99')
    )
      return false;

    let strBase = (ie.trim() + '00000000000').substr(0, 11);
    let strBase2 = ie.length === 9 ? strBase.substr(0, 8) : strBase.substr(0, 2) + strBase.substr(4, 6);
    let intSoma = 0;

    for (let intPos = 1; intPos <= 8; intPos++) {
      let intValor = Number(strBase2.substr(intPos - 1, 1));
      intValor = intValor * (10 - intPos);
      intSoma = intSoma + intValor;
    }

    let intResto = intSoma % 11;
    let strDigito1 = (intResto < 2 ? '0' : (11 - intResto).toString()).substr(
      (intResto < 2 ? '0' : (11 - intResto).toString()).length - 1
    );
    strBase2 = strBase.substr(0, ie.length === 9 ? 8 : 10) + strDigito1;

    return strBase2 == ie;
  }
}
